import {
  FACEBOOK,
  SNAPCHAT,
  REMERGE,
  ADIKTEEV,
  IRONSOURCE,
  TABOOLA,
  MOLOCO,
  GOOGLE_ADS,
  TIKTOK,
  BING,
  YOUAPPI,
  APPLOVIN,
  TWITTER,
  DEV,
} from 'scenes/CustomAudiences/constants';

import Adikteev from './Adikteev';
import AppLovin from './AppLovin';
import Bing from './Bing';
import Facebook from './Facebook';
import GoogleAds from './GoogleAds';
import IronSource from './IronSource';
import Moloco from './Moloco';
import Remerge from './Remerge';
import Snapchat from './Snapchat';
import Taboola from './Taboola';
import TikTok from './TikTok';
import Twitter from './Twitter';
import YouAppi from './YouAppi';
import Dev from './Dev';

export const getComponent = (partner) => {
  switch (partner) {
    case FACEBOOK:
      return Facebook;
    case SNAPCHAT:
      return Snapchat;
    case REMERGE:
      return Remerge;
    case ADIKTEEV:
      return Adikteev;
    case IRONSOURCE:
      return IronSource;
    case TABOOLA:
      return Taboola;
    case MOLOCO:
      return Moloco;
    case TIKTOK:
      return TikTok;
    case GOOGLE_ADS:
      return GoogleAds;
    case BING:
      return Bing;
    case YOUAPPI:
      return YouAppi;
    case APPLOVIN:
      return AppLovin;
    case TWITTER:
      return Twitter;
    case DEV:
      return Dev;
    default:
      return null;
  }
};
